import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b97a7c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLBidCar" }
const _hoisted_2 = { class: "FTLBidCar__container" }
const _hoisted_3 = { class: "container__block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Оформление машины", -1))
const _hoisted_5 = { class: "block__content" }
const _hoisted_6 = { class: "block__field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Перевозчик", -1))
const _hoisted_8 = { class: "field__value" }
const _hoisted_9 = { class: "block__field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Марка авто", -1))
const _hoisted_11 = { class: "field__value" }
const _hoisted_12 = { class: "block__field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Гос. номер", -1))
const _hoisted_14 = { class: "field__value" }
const _hoisted_15 = { class: "block__field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Водитель", -1))
const _hoisted_17 = { class: "field__value" }
const _hoisted_18 = { class: "block__field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Номер телефона водителя", -1))
const _hoisted_20 = { class: "field__value" }
const _hoisted_21 = { class: "block__field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Номер удостоверения водителя", -1))
const _hoisted_23 = { class: "field__value" }
const _hoisted_24 = { class: "block__field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Номер водительских прав водителя", -1))
const _hoisted_26 = { class: "field__value" }
const _hoisted_27 = { class: "block__field" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Гос. номер прицепа", -1))
const _hoisted_29 = { class: "field__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.carrierName || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.carBrand || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.carNumber || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.driverName || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.driverPhone || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.driverIdNumber || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.driverLicenseNumber || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.trailerLicenseNumber || '-'), 1)
          ])
        ])
      ])
    ])
  ]))
}